import { useGetUserPlanQuery } from '@/redux/api/api.caller';
// TR-480 [TẠM - DEV ONLY]: giữ import để mở lại gate nhanh (đang bị bỏ qua bên dưới).
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { STRATEGY_CALL_MIN_ORDERS } from '@/constants';

export interface StrategyCallEligibility {
  isEligible: boolean;
  orderCountLastMonth: number;
}

/**
 * TR-480: xét shop có đủ điều kiện thấy CTA "1:1 Strategy Call" hay không.
 * Điều kiện: số order tháng dương lịch liền trước (`orderCountLastMonth`) >= STRATEGY_CALL_MIN_ORDERS.
 * Mặc định an toàn `false` khi data chưa load / field thiếu (undefined → 0 → không eligible).
 */
export const useStrategyCallEligibility = (): StrategyCallEligibility => {
  const { data } = useGetUserPlanQuery({});
  const orderCountLastMonth = data?.data?.orderCountLastMonth ?? 0;

  // TR-480 [TẠM - DEV ONLY]: bỏ điều kiện eligibility để test demo call trên development bất kể số đơn.
  // MỞ LẠI trước khi merge: đổi `const isEligible = true;` -> `const isEligible = orderCountLastMonth >= STRATEGY_CALL_MIN_ORDERS;`
  // và bỏ dòng eslint-disable ở import STRATEGY_CALL_MIN_ORDERS.
  const isEligible = true;

  return {
    isEligible,
    orderCountLastMonth,
  };
};
